import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  results: [],
  total: 0,
  counts: {}
}

export const content = createSlice({
  name,
  initialState,
  reducers: {
    setResults: (state, { payload: { content, total, counts } }) => {
      state.results = content
      state.total = total
      state.counts = { ...state.counts, ...counts }
    },
    reset: () => initialState
  }
})

export const { setResults, reset } = content.actions

export default content.reducer
